export const MAX_INTEGER = 0x7fffffff

export const QUERY_KEYS = {
  appInfo: 'appInfo',
  getSpareparts: 'getSpareparts',
  getRefillAlert: 'getRefillAlert',
  getAddressSearch: 'getAddressSearch',
  getSpools: 'getSpools',
  getDevices: 'getDevices',
  getDeviceById: 'getDeviceById',
  getProfile: 'getProfile',
  getPackByReference: 'getPackByReference',
  getSites: 'getSites',
  getSiteById: 'getSiteById',
  getServices: 'getServices',
  getResellers: 'getResellers',
  getSessionsCount: 'getSessionsCount',
  getUsedSpools: 'getUsedSpools',
  getStockAdditions: 'getStockAdditions',
  getSpoolsLifetime: 'getSpoolsLifetime',
  getPulledLength: 'getPulledLength',
} as const
